import React from 'react'

const ReactSharedInternals =
  React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED ??
  React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE ??
  React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE

export function internalsIsRendering() {
  return (
    typeof ReactSharedInternals?.ReactCurrentOwner?.current?.lanes === 'number'
  )
}

/**
 * 这里需要严格检测所有用到的内部属性，防止内部 API 变更
 */
function internalsIsExisted() {
  return ReactSharedInternals?.ReactCurrentOwner?.current !== undefined
}

export const internalsCanIUse = internalsIsExisted()
